import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const ServiceCard = ({ service, onLearnMore }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="bg-card rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={service?.image}
          alt={service?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute top-4 right-4 bg-transparent backdrop-blur-sm px-3 py-1 rounded-full">
          <span className="text-xs font-semibold text-primary">
            {service?.category}
          </span>
        </div>
        <div className="absolute bottom-4 left-4">
          <div
            className={`w-12 h-12 bg-primary rounded-lg flex items-center justify-center transition-transform duration-300 ${
              isHovered ? "rotate-12 scale-110" : ""
            }`}
          >
            <Icon name={service?.icon} size={24} color="#ffffff" />
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-bold text-foreground mb-2 line-clamp-1">
          {service?.title}
        </h3>
        <p className="text-sm md:text-base text-text-secondary mb-4 line-clamp-3">
          {service?.description}
        </p>

        <div className="space-y-2 mb-4">
          {service?.features?.slice(0, 3)?.map((feature, index) => (
            <div key={index} className="flex items-start gap-2">
              <Icon
                name="CheckCircle2"
                size={16}
                color="var(--color-success)"
                className="mt-1 flex-shrink-0"
              />
              <span className="text-xs md:text-sm text-text-secondary line-clamp-1">
                {feature}
              </span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-2">
            <Icon name="TrendingUp" size={16} color="var(--color-success)" />
            <span className="text-xs md:text-sm font-semibold text-success">
              {service?.roi}
            </span>
          </div>
          <button
            onClick={() => onLearnMore(service)}
            className="
    inline-flex items-center gap-2
    px-4 py-2
    text-sm font-semibold
    rounded-full
    bg-indigo-600 text-white
    hover:bg-indigo-700
    transition-all duration-300
    shadow-md hover:shadow-lg
  "
          >
            Learn More
            <Icon name="ArrowRight" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
